import React from 'react';
import { BookOpenIcon, CompassIcon, NotebookPenIcon, ShieldIcon, WavesIcon } from 'lucide-react';
import { stack, type StackItem } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons: Record<StackItem['icon'], typeof BookOpenIcon> = {
  book: BookOpenIcon,
  spiral: WavesIcon,
  compass: CompassIcon,
  shield: ShieldIcon,
  notebook: NotebookPenIcon
};
export function ProductStack() {
  return <section aria-labelledby="contenido" className="w-full bg-ink" data-id="element-142" data-mp="dc70i1y7ujkm">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-143" data-mp="ibjsf13y2gu2">
        <SectionHeading eyebrow="Contenido del producto" title="¿Qué hay dentro del Master Kit Memorias del Alma™?" data-id="element-144" data-mp="i9qi9bu4hehb" />

        <ul className="mt-12 divide-y divide-line border-t border-line" data-id="element-145" data-mp="r45642spxxc1">
          {stack.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="grid gap-4 py-7 sm:grid-cols-[auto_1fr_1fr] sm:items-start sm:gap-8" data-id="element-146" data-mp="w5b0e5211sno">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-line bg-ink-raised text-amethyst" data-id="element-147" data-mp="110gh8pgkoh4w">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-148" data-mp="1e1of6tnj1ltt" />
                </span>
                <h3 className="font-sans text-[17px] font-semibold leading-snug text-cream" data-id="element-149" data-mp="1a0b7ee0vj8k9">
                  {item.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-muted" data-id="element-150" data-mp="1532oucbtd2ih">{item.detail}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}